module.exports = __webpack_public_path__ + "0206f3f87fccb3ce94361d3464fdd0c3.png";